import { useSubscribe } from "providers/Messages";

const useUpdateRetailStoreLocation = () => {
  useSubscribe((message) => {
    if (message.type === "COMMAND:SET_RETAIL_STORE_LOCATION") {
      localStorage.setItem(
        "retailStoreLocation",
        message.payload.retailStoreLocation
      );
      localStorage.setItem("retailStoreName", message.payload.retailStoreName);
      localStorage.setItem("channelType", message.payload.channelType);
    }
  });
};

export { useUpdateRetailStoreLocation };
